import {status, STATUS_MODEL} from "../../../../enums/statusEnum";
import CustomUserChip from "../../../../components/CustomUserChip";
import {
    CalendarIcon,
    CloseIcon, DocumentationIcon,
    IconCloseChip
} from "../../../../components/buttons/IconButtons";
import {POSITION_MODEL} from "../../../../Helpers/PositionModel";
import CustomChip from "../../../../components/CustomChip";
import {
    chipStatusIconClassColor,
    statusBorderColor,
    statusColor,
    statusFontColor
} from "../../../../enums/statusColorEnum";
import {DATE_TIME_FORMAT_NAME_MODEL, EMPTY_VALUES, getDateFormat} from "../../../../Apis/functions";
import React, {forwardRef, useEffect, useRef, useState} from "react";
import CustomGenericTittleIconDataChip from "../../../../components/CustomGenericTittleIconDataChip";
import LevelRequestCard from "./LevelRequestCard";
import UploadImageModal from "../../../../components/UploadImageModal";
import {FILE_TYPE} from "../../../../Helpers/fileType";
import {REQUEST_DOCUMENTATION_ICON_MODEL} from "../Model/Model";
import CustomTooltip from "../../../../components/CustomTooltip";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 05/12/2025
 */

const RequestLevels = ({
    t,
    item,
    handleChange,
    emptyFields,
    showModal,
    setShowModal,
    photoPicker,
    setPhotoPicker,
    setActiveLevelIndex,
    levelRefsRef,
    period,
    documentationApproval,
    highlightedLevel,
   containerHeightRef
}) => {
    const IconComponent = REQUEST_DOCUMENTATION_ICON_MODEL[documentationApproval] || (() => null);
    const [showBadgeMessage, setShowBadgeMessage] = useState(true);
    const handleCloseBadge = () => {
        setShowBadgeMessage(false);
    }
    const levelRefs = useRef([]);

    useEffect(() => {
        levelRefsRef.current = levelRefs.current;
    }, [item]);

    return (
          <>
              <div className={"border-radius-8px border-full-shades-100 p-0 m-0 h-100"}>
                  <div className={"col-12 d-flex justify-content-between align-items-center py-12px px-3 row"}>
                      <div className={"col-12 col-md-12 col-lg-4"}>
                          <CustomGenericTittleIconDataChip
                              className="m-0"
                              Icon={DocumentationIcon}
                              title="required_information"
                              border={false}
                          />
                      </div>
                      <div className={"d-flex justify-content-end align-items-center col-12 col-lg-8"}>
                          <div className={"d-flex gap-3 align-items-center"}>
                              {t("period") + ":"}
                              <CustomUserChip
                                  className={"mt-0 chip-shades-300-50"}
                                  key={item?.id}
                                  name={ <CustomTooltip
                                      text={`${getDateFormat(period?.startDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)}
                                     - ${period?.endDate ? getDateFormat(new Date(new Date(period?.endDate)) , true, DATE_TIME_FORMAT_NAME_MODEL.shortMonth) : t("forever")}` }
                                      classes={`fs-14px text-ellipsis-1-row`}
                                      showIfTruncated={true}
                                  />
                                  }
                                  Icon={CalendarIcon}
                                  showAvatar={true}
                                  classNameText={"ibl-font-w-600"}
                                  classNameIcon={"icon-color-shades-400"}
                              />
                          </div>
                          <CustomChip
                              variant={'large'}
                              icon={<IconComponent className={`${chipStatusIconClassColor[documentationApproval]}`}/>}
                              background={statusColor[documentationApproval]}
                              fontColor={statusFontColor[documentationApproval]}
                              borderColor={statusBorderColor[documentationApproval]}
                              legend={t(status[documentationApproval]) || EMPTY_VALUES.DEFAULT}
                              classNameIcon={"w-h-24px"}
                              className={"py-2 px-12px h-40px minh-40px maxh-40px"}
                          />
                      </div>
                  </div>
                  <div className="border-bottom-shades-300 p-0 m-0"/>
                  { (showBadgeMessage && documentationApproval === STATUS_MODEL.DENIED) &&
                  <div className={'col-12 py-12px'}>
                      <CustomUserChip
                          className={'m-0 chip-error-code-150-100 w-100 px-1 py-12px justify-content-start'}
                          name={t("message_badge_denied")}
                          Icon={IconCloseChip}
                          showAvatar={true}
                          classNameText={"m-1"}
                          classNameBoxText={"px-1"}
                          classNameIcon="icon-color-error-code-700 w-h-24px"
                          variant='large'
                          iconPosition={POSITION_MODEL.LEFT}
                          onDelete={() => handleCloseBadge() }
                          deleteIcon={<CloseIcon fontSize='small' height={16} width={16} className="icon-color-error-code-700"/>}
                      />
                  </div>
                  }
                  <div className={"p-16px position-relative overflow-y-auto"} ref={containerHeightRef}>
                      {
                          item?.levels?.map((level, index) => {
                              let disabled = true;

                              if ([STATUS_MODEL.APPROVED, STATUS_MODEL.DENIED].includes(documentationApproval)) {
                                  if (index === 0) {
                                      disabled = false;
                                  } else {
                                      const prevLevel = item?.levels?.[index - 1];
                                      if (prevLevel?.userLevel?.statusId === STATUS_MODEL.APPROVED) {
                                          disabled = false;
                                      }
                                  }
                              }
                              if (!levelRefs.current[index]) {
                                  levelRefs.current[index] = React.createRef();
                              }
                              return (
                                  <div key={level?.id ?? index} ref={levelRefs.current[index]}>
                                      <LevelRequestCard
                                          due={period?.leadDays}
                                          item={level}
                                          index={index}
                                          disabled={disabled}
                                          t={t}
                                          handleChange={handleChange}
                                          emptyFields={emptyFields}
                                          setShowModal={setShowModal}
                                          setActiveLevelIndex={setActiveLevelIndex}
                                          documentationApproval={documentationApproval}
                                          highlightedLevel={highlightedLevel}
                                      />
                                  </div>
                              );
                          })
                      }
                  </div>
              </div>
              <UploadImageModal
                  title={t('submit_file')}
                  show={showModal}
                  onHide={() => setShowModal(false)}
                  photoPicker={photoPicker}
                  setPhotoPicker={setPhotoPicker}
                  showBtnCamera={false}
                  fileType={FILE_TYPE.IMAGE_FILES}
                  showPreview={false}
              />
          </>
    )
}

export default RequestLevels
